module.exports = __webpack_public_path__ + "static/img/courseVideoImg.2426379.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/courseVideoImg.jpg
// module id = zkVf
// module chunks = 1